import {MenuNodeModel} from './menu-node.model';

export class MenuItem implements MenuNodeModel{

  public active = false;                    // l'item sarà visibile
  public dependent = false;                // l'item dipende da altri item

  public pathToCheck;

  constructor(public name: string,
              public icon: string,
              public path: string,
              public label: string,
              public depending?: MenuItem[]) {}


  public getChildren(): MenuNodeModel[] {
    return [];
  }
  
  public isActive(): boolean {
    return this.active;
  }

  public isLeaf(): boolean {
    return true;
  }
}